import { render, staticRenderFns } from "./ProfileRow.vue?vue&type=template&id=51b44d29&lang=pug"
import script from "./ProfileRow.vue?vue&type=script&lang=ts"
export * from "./ProfileRow.vue?vue&type=script&lang=ts"
import style0 from "./ProfileRow.vue?vue&type=style&index=0&id=51b44d29&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports